export const YOUTUBE_URL_RE =
  /^https?:\/\/(www\.|m\.)?(youtube\.com\/(watch\?v=|embed\/|shorts\/|live\/)[\w-]+|youtu\.be\/[\w-]+)(\S*)?$/

const YOUTUBE_ID_RE = /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/|live\/)|youtu\.be\/)([\w-]+)/

export function getYouTubeVideoId(url: string): string | null {
  if (!url) return null
  const match = url.match(YOUTUBE_ID_RE)
  return match?.[1] ?? null
}

export function getYouTubeEmbedUrl(url: string): string | null {
  const id = getYouTubeVideoId(url)
  if (!id) return null
  const params = 'rel=0&modestbranding=1&iv_load_policy=3&playsinline=1'
  return `https://www.youtube-nocookie.com/embed/${id}?${params}`
}

export function getYouTubeThumbnailUrl(url: string): string | null {
  const id = getYouTubeVideoId(url)
  return id ? `https://img.youtube.com/vi/${id}/hqdefault.jpg` : null
}
